module.exports = __webpack_public_path__ + "media/images/mailer/shopping_cart-48-primary-a27df22a2a4e3f766ee70d778803e721.png";